import { handleActions } from 'redux-actions'
import { SET_LOADING_STATE, SET_ERROR_MESSAGE } from '../constants/commonConstant'
import { handleStateChange } from '../utils'

export let common = handleActions({
  [SET_LOADING_STATE]: handleStateChange,
  [SET_ERROR_MESSAGE]: (state, action) => {
    return { loading: false, errorMessage: action.payload }
  }
}, {
  loading: false,
  errorMessage: ''
})
